import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Link } from '@mui/material';
import moment from 'moment';
import { Table, WaitDialog } from '@components';
import { useModal } from 'mui-modal-provider';
const OblerVisitasListView = ({ $state, UIService, OblInteracaoService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const [tecnicos, setTecnicos] = useState([]);
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: '#',
            size: 100,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Processo.numeroProcesso',
            header: 'Nº Processo',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Processo.Cliente.nome',
            header: 'Parceiro',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Processo.parceiro',
            header: 'Nº Parceiro',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.processos.details', { id: row.original.processoId }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Agendamento.data',
            header: 'Agendamento',
            size: 100,
            Cell: ({ row }) => (row.original.data && moment(row.original.data).isValid() ? moment(row.original.data).format('DD/MM/YYYY') : 'N/D')
        },
        {
            accessorKey: 'Agendamento.hora',
            header: '',
            size: '60',
            Cell: ({ renderedCellValue }) => renderedCellValue.substring(0, 5)
        },
        {
            accessorKey: 'Agendamento.tecnicoId',
            exportKey: 'Agendamento.Funcionario.name',
            header: 'Técnico',
            filterSelectOptions: tecnicos.map(r => ({
                value: r.id,
                label: r.name
            })),
            Cell: ({ row }) => row.original.Agendamento?.Funcionario?.name ?? '-'
        },
        {
            accessorKey: 'dataSubmissao',
            header: 'Data de submissão',
            size: 150,
            Cell: ({ row }) => (row.original.dataSubmissao && moment(row.original.dataSubmissao).isValid() ? moment(row.original.dataSubmissao).format('DD/MM/YYYY HH:mm') : 'N/D')
        },
        {
            accessorKey: 'realizada',
            header: 'Realizada?',
            Cell: ({ row }) => {
                return row.original.realizada == 1 ? 'Sim' : 'Não';
            }
        },
        {
            accessorKey: 'validado',
            header: 'Validado?',
            Cell: ({ row }) => {
                return row.original.validado == 1 ? 'Sim' : 'Não';
            }
        }
    ], [tecnicos]);
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const initialFetch = async () => {
        if (loading) {
            setLoading(false);
            const opt = await OblInteracaoService.options();
            setOptions(opt);
            const rTecnicos = await OblInteracaoService.findTecnicos();
            setTecnicos(rTecnicos);
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await OblInteracaoService.tableVisitas({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
        }
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    const excelGen = async (id, array) => {
        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
        let filename = `obler-visitas-${id ? 'selecao' : 'exportacao'}-${moment().format('YYYY-MM-DD-HH-mm-ss')}.xlsx`;
        let filters = {};
        filter.forEach(r => {
            filters[r.id] = `${getType(r.type)}:${r.value}`;
        });
        if (id) {
            filters['id'] = `$in:${array.join(',')}`;
        }
        else {
            // Aplica filtro temporal
        }
        let sorter = [];
        sort.forEach(r => {
            sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
        });
        try {
            let o = await OblInteracaoService.export({
                columns: columns.map((r) => {
                    return {
                        accessorKey: r.exportKey ?? r.accessorKey,
                        header: r.header
                    };
                }),
                filter: filters,
                sortBy: sorter
            });
            if (o) {
                // Decode Base64 and convert to a Blob
                const binary = atob(o.$data);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                // Create a Blob and save it as an Excel file
                const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
        }
        catch (e) {
            if (e && e.data) {
                UIService.addToast(e.data.message);
            }
            else {
                UIService.addToast('Ocorreu um erro ao exportar dados!');
            }
        }
        wait.destroy();
    };
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Obler
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            Visitas Técnicas
          </Link>
        </Breadcrumbs>
      </Box>

      <Box>
        <Table onDoubleClick={row => {
            window.open($state.href('app.obler.processos.details', { id: row.processoId }, { absolute: true }));
        }} storageKey={$state.current.name} data={data} columns={columns} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} onExport={async () => {
            excelGen(false, []);
        }} quickFilterPresets={[
            {
                key: 'por-validar',
                label: 'Por validar',
                tooltip: 'Visitas técnicas que necessitam de nova intervenção',
                filters: [
                    { id: 'validado', value: 0, type: 'equals' },
                    { id: 'realizada', value: 1, type: 'equals' },
                    { id: 'dataSubmissao', value: '', type: 'notEmpty' }, // was notEquals:null
                ],
            },
            {
                key: 'nao-realizadas',
                label: 'Não realizadas',
                tooltip: 'Visitas técnicas não realizadas pelo técnico',
                filters: [
                    { id: 'realizada', value: 0, type: 'equals' },
                    { id: 'dataSubmissao', value: '', type: 'notEmpty' }, // was notEquals:null
                ],
            },
        ]}/>
      </Box>
    </Box>);
};
export default OblerVisitasListView;
